import { render, staticRenderFns } from "./SampleProcessesModal.vue?vue&type=template&id=35f88160&scoped=true&"
import script from "./SampleProcessesModal.ts?vue&type=script&lang=ts&"
export * from "./SampleProcessesModal.ts?vue&type=script&lang=ts&"
import style0 from "./SampleProcessesModal.scss?vue&type=style&index=0&id=35f88160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f88160",
  null
  
)

export default component.exports